export enum VALIDATION_MAP_KEYS {
  INPUT = 'input',
  CONTRACT = 'contract',
  CLIENT_EDITOR = 'clientEditor',
  PRINT_MODAL_CONTRACT = 'printModalContract',
  EVB_MODAL = 'EVBModal',
  PREIS_IN_1914_CALCULATOR = 'preisIn1914Calculator',
}
